import { SortCategory, } from '@thoughtspot/ts-chart-sdk';
import _ from 'lodash';
import { ColumnSortCategory, } from '../types/prism';
import { mapAnswerColumnToCustomColumns, mapLegacyColumnsToCustomColumns, } from './answer-column-adaptor.util';
import { mapCustomChartConfigToSDKConfig } from './custom-chart-config-adaptor.util';
export const mapLegacyAxisConfigToCustomAxisConfig = (axisConfig) => {
    const configs = _.compact(Object.keys(axisConfig).map((key) => {
        if (_.isEmpty(axisConfig[key]) || key === '__typename') {
            return null;
        }
        const columns = (_.isArray(axisConfig[key])
            ? axisConfig[key]
            : [axisConfig[key]]);
        return {
            key: key,
            columns: columns.map((col) => mapAnswerColumnToCustomColumns(col)),
        };
    }));
    const chartConfig = {
        key: 'default',
        dimensions: configs,
    };
    return chartConfig;
};
export const processLegacyDataToSDKQueryData = (data) => {
    return data.map((dataArr) => {
        const columns = dataArr.columnDataLite.map((colData) => colData.columnId);
        const points = _.reduce(dataArr.columnDataLite[0].dataValue, (acc, _colData, idx) => {
            const point = dataArr.columnDataLite.map((colData) => colData.dataValue[idx]);
            acc.push(point);
            return acc;
        }, []);
        return {
            data: {
                columns,
                dataValue: points,
            },
            totalRowCount: parseInt(dataArr.totalRowCount, 10),
        };
    });
};
export const mapLegacySortInfoToSDKSortInfo = (sortInfo) => {
    const categoryMap = {
        [ColumnSortCategory.Default]: SortCategory.DEFAULT,
        [ColumnSortCategory.None]: SortCategory.NONE,
        [ColumnSortCategory.Alpha]: SortCategory.ALPHA,
        [ColumnSortCategory.Custom]: SortCategory.CUSTOM,
    };
    return sortInfo.map(sort => ({
        ...sort,
        category: categoryMap[sort.category],
        columnId: sort.columnId,
        sortAscending: sort.sortAscending,
    }));
};
export const processLegacyChartModelToCustomChartModel = (chartModel, chartData) => {
    const columnProperties = chartModel.vizProp.columnProperties || [];
    const columns = mapLegacyColumnsToCustomColumns(chartModel.columns, columnProperties);
    const data = processLegacyDataToSDKQueryData(chartData);
    let chartConfig = [];
    if (!_.isNil(chartModel.config.customChartConfig) &&
        !_.isEmpty(chartModel.config.customChartConfig)) {
        chartConfig = mapCustomChartConfigToSDKConfig(chartModel.config.customChartConfig, chartModel.columns, columnProperties);
    }
    const customChartModel = {
        columns,
        data,
        sortInfo: mapLegacySortInfoToSDKSortInfo(chartModel.sortInfo),
        visualProps: chartModel.customVisualProps,
        config: {
            chartConfig,
        },
        id: chartModel.id,
        visualOverrides: chartModel.visualOverrides,
    };
    return customChartModel;
};
//# sourceMappingURL=chart-model-adaptor.util.js.map